export enum Currency {
  CAD = 'CAD',
  USD = 'USD',
  EUR = 'EUR',
}
